import http from '@/utils/http'

export function regionBldCells(params) {
	return http.get("/api/weixin/regionBldCells", {
		params: params
	})
}

export function cellHouses(params) {
	return http.get("/api/weixin/cellFloorSummary", {
		params: params
	});
}

export function fetchMyHouses() {
	return http.get("/api/weixin/fetchMyHouses")
}

export function fetchHouseInfo(houseId) {
	return http.get("/api/weixin/house/" + houseId)
}